import { useCallback } from "react";
import { useUserContext } from "../useUserContext";
import { markSupportTicketReadByUser } from "@/app/_firebase/support";

const useMarkSupportTicketRead = () => {
  const user = useUserContext();

  return useCallback(
    async (ticketId: string) => {
      try {
        await markSupportTicketReadByUser(user.uid, ticketId);
      } catch (error) {
        console.error("Failed to mark support ticket read", error);
      }
    },
    [user.uid]
  );
};

export default useMarkSupportTicketRead;
